import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  captureInitialPublicEntryChannel,
  needsPublicEntryHardNavigation,
  promoteHashGatewayRouteToPublic,
  promoteHashRouteToPath,
  promotePathPublicRouteToHash,
  promotePublicEntryRoute,
} from "@kiraah-shared/mobile-skeleton";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

if (environment.Environment === "PRODUCTION") {
  enableProdMode();
}

const useHashRouting = environment.Environment !== "LOCAL";

captureInitialPublicEntryChannel();

if (needsPublicEntryHardNavigation(useHashRouting)) {
  if (useHashRouting) {
    promotePathPublicRouteToHash();
  }
  promotePublicEntryRoute(useHashRouting);
} else {
  if (useHashRouting) {
    promoteHashGatewayRouteToPublic();
  } else {
    promoteHashRouteToPath();
  }

  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}
